<template>
  <div class="flex flex-col h-full">
    <div v-if="articles.length" class="featured-content">
      <lerner-featured :article="articles[0]"></lerner-featured>
      <div class="relative overflow-hidden w-full">
        <div class="article-carousel">
          <carousel
            v-if="articleSlides.length"
            :loop="true"
            :items="4"
            :margin="8"
            :mouseDrag="false"
            :touchDrag="false"
            :dots="false"
            ref="carousel"
          >
            <template slot="prev">
              <carousel-navigation ref="prevNav" :direction="'prev'"/>
            </template>
            <player-profile-link v-for="article in articleSlides" :key="article.id" :article="article" :show-article-category-icon="true"/>
            <template slot="next">
              <carousel-navigation :direction="'next'"/>
            </template>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import carousel from 'vue-owl';


  import { FETCH_FEATURED_ARTICLES} from '@/store/actions/article.actions';
  import LernerFeatured from '@/component/LernerFeatured';
  import { CHANGE_DOC_TITLE } from '@/store/actions/app.actions';
  import PlayerProfileLink from '@/views/Student/PlayerProfileLink';
  import CarouselNavigation from '@/component/CarouselNavigation';

  export default {
    name: 'index',

    components: {
      PlayerProfileLink,
      LernerFeatured,
      carousel,
      CarouselNavigation
    },

    computed: {
      ...mapGetters(['articles']),
      articleSlides: function () {
        return this.articles.slice(1, 13);
      }
    },

    mounted: function() {
      if (this.articles.length < 13) {
        this.fetchFeaturedArticles();
      }
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: 'Student', useBaseTitle: true})
    },

    methods: {
      fetchFeaturedArticles: function () {
        this.$store.dispatch(FETCH_FEATURED_ARTICLES);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .featured-content {
    padding-top: 196px;

    @media (min-width: config('screens.lg')) {
      padding-top: calc(config('staticHeight.header') + config('staticHeight.categoryCarousel'));
    }
  }
  .article-carousel {
    width: 980px;
    margin: 8px auto 0;
    height: 200px;
  }
</style>
